import Constants from '../utils/consts';
var http = require('follow-redirects').https;
var qs = require('querystring');


export default async function savePDF(username, token, fileName, data) {
    return new Promise(async function (resolve, reject) {
        var options = {
        'method': 'POST',
        'hostname': Constants.ipAddress,
        'path': '/apis/savePDF.php',
        'processData': false,
        'headers': {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cookie': 'uid=e02675a1a7516909792f6850dffcd5fe'
        },
        'maxRedirects': 20
        };

        var req = http.request(options, function (res) {
        var chunks = [];

        res.on("data", function (chunk) {
            chunks.push(chunk);
        });

        res.on("end", function (chunk) {
            var body = Buffer.concat(chunks);
//            console.log(body.toString());
            resolve(JSON.parse(body.toString()));
        });

        res.on("error", function (error) {
            console.error(error);
        });
        });

            var postData = qs.stringify({
                'uname': username,
                'token': token,
                'file_name': fileName,
                'blob': data
            });
       //     console.log(postData);
            req.write(postData);
    
            req.end();        
    });
}
